import { module } from 'modujs';
import { gsap } from 'gsap';

const CLASS_ACTIVE = 'is-active';
const CLASS_ACTIVE_CALLBACK = 'is-active-callback';
const CLASS_HEIGHEST = 'is-heighest';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                button: 'buttonClick',
                job: 'openJob'
            }
        }
    }

    init() {

        this.$buttons = this.$('button');
        this.$lists = this.$('list');
        this.display(0);

        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);

        this.resize();

    }

    buttonClick(e) {
        let elId = parseInt(e.currentTarget.getAttribute('data-id')) - 1;
        
        this.display(elId);
    }

    openJob(e) {
        let slug = e.currentTarget.getAttribute('data-slug');

        console.log(slug);
        
        this.call('open',{},'Popup',slug);
    }

    display(id) {
        let activeButton, activeList;

        if(this.delayCallback != undefined) {
            this.delayCallback.kill();
        }

        this.$buttons.forEach((el) => {
            let elId = parseInt(el.getAttribute('data-id')) - 1;

            if(elId == id) {
                activeButton = el;
                el.classList.add(CLASS_ACTIVE);
            } else {
                el.classList.remove(CLASS_ACTIVE);
                el.classList.remove(CLASS_ACTIVE_CALLBACK);
            }

        });
        this.$lists.forEach((el) => {
            let elId = parseInt(el.getAttribute('data-id')) - 1;

            if(elId == id) {
                activeList = el;
                el.classList.add(CLASS_ACTIVE);
            } else {
                el.classList.remove(CLASS_ACTIVE);
                el.classList.remove(CLASS_ACTIVE_CALLBACK);
            }
        });

        this.delayCallback = gsap.delayedCall(0.4,() =>{
            activeList.classList.add(CLASS_ACTIVE_CALLBACK);
            activeList.classList.add(CLASS_ACTIVE_CALLBACK);
        })
    }

    checkHeight() {
        let maxHeight = 0;
        let maxHeightEl;
        
        this.$lists.forEach((el) => {
            el.classList.remove(CLASS_HEIGHEST)

            let h = el.getBoundingClientRect().height;
            if(h > maxHeight) {
                maxHeight = h;
                maxHeightEl = el;
            }
        });

        maxHeightEl.classList.add(CLASS_HEIGHEST)
    }

    resize(){
        this.checkHeight();
    }
}
